export default __webpack_public_path__ + "static/media/italo.4db1f9ed.svg";